import React from "react";
interface props {
  className: string;
}

function Icon3({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //   width="34"
      //   height="34"
      className={className}
      fill="none"
      viewBox="0 0 34 34"
    >
      <path
        fill="#666"
        d="M14.057 12.041h-3.886a8.57 8.57 0 018.342-3.415.504.504 0 00.163-.994 9.598 9.598 0 00-9.155 3.58V7.503a.504.504 0 00-1.009 0v5.041a.504.504 0 00.504.504h5.041a.504.504 0 000-1.008zm-1.512 7.561a.504.504 0 00-.504.505v3.886a8.57 8.57 0 01-3.415-8.342.504.504 0 00-.994-.163 9.598 9.598 0 003.58 9.156H7.503a.504.504 0 000 1.008h5.041a.505.505 0 00.504-.504v-5.041a.504.504 0 00-.504-.505zm12.603 1.513h-5.041a.504.504 0 000 1.008h3.886a8.57 8.57 0 01-8.342 3.415.504.504 0 00-.163.994c.527.085 1.06.128 1.594.128a9.599 9.599 0 007.562-3.707v3.707a.504.504 0 101.008 0v-5.041a.504.504 0 00-.504-.504zM26.66 8.512h-5.041a.504.504 0 00-.504.504v5.041a.505.505 0 001.008 0v-3.891a8.367 8.367 0 012.377 2.633 8.51 8.51 0 011.152 4.283c0 .48-.038.957-.114 1.43a.504.504 0 00.994.164c.085-.527.128-1.06.128-1.594a9.518 9.518 0 00-1.285-4.786 9.376 9.376 0 00-2.417-2.775h3.702a.504.504 0 100-1.009z"
      ></path>
    </svg>
  );
}

export default Icon3;
